var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EOL',{attrs:{"lgSize":12,"lgOffset":0,"locParam":1,"idCity":0}})}
var staticRenderFns = []

export { render, staticRenderFns }